exports.isValid = (value) => {
    if (value === undefined || value === null) {
        return false;
    }

    if (typeof value === 'boolean') {
        return true;
    }

    if (typeof value === 'number') {
        return true;
    }

    if (typeof value === 'string') {
        return value.trim().length > 0;
    }

    return false;
}
